import { Apple, Smartphone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { EyebrowBadge } from "../atoms/eyebrow-badge";
import { PhoneFrame } from "../atoms/phone-frame";
import { PhoneMockupScreen } from "../atoms/phone-mockup-screen";
import { SectionHeading } from "../atoms/section-heading";

interface LandingAppSectionProps {
	communityName: string;
	appName: string | null;
	iconUrl: string | null;
	splashColor: string | null;
	primaryColor: string | null;
}

export function LandingAppSection({ communityName, appName, iconUrl, splashColor, primaryColor }: LandingAppSectionProps) {
	const { t } = useTranslation("community");

	return (
		<section className="landing-bg-brand-gradient relative overflow-hidden py-24 md:py-32">
			<div className="landing-bg-grid absolute inset-0 opacity-30" aria-hidden />
			<div className="relative mx-auto grid w-full max-w-7xl gap-16 px-6 md:grid-cols-2 md:items-center">
				<div className="order-2 flex justify-center md:order-1 md:justify-start">
					<PhoneFrame tilt="left" size="md" label={`${communityName} app preview`}>
						<PhoneMockupScreen
							communityName={communityName}
							appName={appName}
							iconUrl={iconUrl}
							splashColor={splashColor}
							primaryColor={primaryColor}
						/>
					</PhoneFrame>
				</div>
				<div className="order-1 flex flex-col gap-8 md:order-2">
					<SectionHeading
						eyebrow={<EyebrowBadge tone="white">{t("landing.app.eyebrow")}</EyebrowBadge>}
						title={t("landing.app.title", { communityName })}
						titleAccent={t("landing.app.title_accent")}
						description={t("landing.app.description")}
						align="left"
						tone="white"
					/>
					<div className="flex flex-wrap items-center gap-3">
						<button
							type="button"
							disabled
							className="flex h-14 items-center gap-3 rounded-2xl border border-white/20 bg-white/10 px-5 text-left text-white opacity-70 backdrop-blur"
						>
							<Apple className="h-7 w-7" aria-hidden />
							<span className="flex flex-col">
								<span className="text-[10px] uppercase tracking-wider text-white/60">{t("landing.app.coming_soon")}</span>
								<span className="text-sm font-semibold">{t("home_app_store")}</span>
							</span>
						</button>
						<button
							type="button"
							disabled
							className="flex h-14 items-center gap-3 rounded-2xl border border-white/20 bg-white/10 px-5 text-left text-white opacity-70 backdrop-blur"
						>
							<Smartphone className="h-7 w-7" aria-hidden />
							<span className="flex flex-col">
								<span className="text-[10px] uppercase tracking-wider text-white/60">{t("landing.app.coming_soon")}</span>
								<span className="text-sm font-semibold">{t("home_play_store")}</span>
							</span>
						</button>
					</div>
				</div>
			</div>
		</section>
	);
}
